import { render, staticRenderFns } from "./google_oauth_btn.vue?vue&type=template&id=181c9852&scoped=true&lang=pug&"
import script from "./google_oauth_btn.vue?vue&type=script&lang=js&"
export * from "./google_oauth_btn.vue?vue&type=script&lang=js&"
import style0 from "./google_oauth_btn.vue?vue&type=style&index=0&id=181c9852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181c9852",
  null
  
)

export default component.exports